// ACTION CREATOR SET_SAVE_MARKER_SELECTED
export const SET_SAVE_MARKER_SELECTED = 'SET_SAVE_MARKER_SELECTED';

// ACTION CREATOR setSaveMarkerSelected
export const setSaveMarkerSelected = (value) => ({
  type: SET_SAVE_MARKER_SELECTED,
  value,
});

// ACTION CREATOR SET_MULTIPLE_MARKER
export const SET_MULTIPLE_MARKER = 'SET_MULTIPLE_MARKER';

// ACTION CREATOR setMultipleMarker
export const setMultipleMarker = (value) => ({
  type: SET_MULTIPLE_MARKER,
  value,
});

// ACTION CREATOR SET_SAVE_MARKER_COMPONENT
export const SET_SAVE_MARKER_COMPONENT = 'SET_SAVE_MARKER_COMPONENT';

// ACTION CREATOR setSaveMarkerComponent
export const setSaveMarkerComponent = (value) => ({
  type: SET_SAVE_MARKER_COMPONENT,
  value,
});

// ACTION CREATOR SET_SAVE_MULTIPLE_METADATA_ARRAY
export const SET_SAVE_MULTIPLE_METADATA_ARRAY = 'SET_SAVE_MULTIPLE_METADATA_ARRAY';

// ACTION CREATOR setSaveMultipleMetadataArray
export const setSaveMultipleMetadataArray = (value) => ({
  type: SET_SAVE_MULTIPLE_METADATA_ARRAY,
  value,
});

// ACTION CREATOR SAVED_MULTIPLE_GRID_ROWS
export const SAVED_MULTIPLE_GRID_ROWS = 'SAVED_MULTIPLE_GRID_ROWS';

// ACTION CREATOR saveMultipleGridRows
export const saveMultipleGridRows = (value) => ({
  type: SAVED_MULTIPLE_GRID_ROWS,
  value,
});

// ACTION CREATOR SET_SAVE_MULTIPLE_METADATA_ARRAY_LIST_NAME
export const SET_SAVE_MULTIPLE_METADATA_ARRAY_LIST_NAME = 'SET_SAVE_MULTIPLE_METADATA_ARRAY_LIST_NAME';

// ACTION CREATOR setSaveMultipleMetadataArrayListName
export const setSaveMultipleMetadataArrayListName = (value) => ({
  type: SET_SAVE_MULTIPLE_METADATA_ARRAY_LIST_NAME,
  value,
});

// ACTION CREATOR SET_SAVE_FULL_DATA_SELECTED_STATIONS
export const SET_SAVE_FULL_DATA_SELECTED_STATIONS = 'SET_SAVE_FULL_DATA_SELECTED_STATIONS';

// ACTION CREATOR setSaveFullDataSelectedStations
export const setSaveFullDataSelectedStations = (value) => ({
  type: SET_SAVE_FULL_DATA_SELECTED_STATIONS,
  value,
});

// ACTION CREATOR SET_SAVE_MULTIPLE_LINEAR_OPTION
export const SET_SAVE_MULTIPLE_LINEAR_OPTION = 'SET_SAVE_MULTIPLE_LINEAR_OPTION';

// ACTION CREATOR setSaveMultipleLinearOption
export const setSaveMultipleLinearOption = (value) => ({
  type: SET_SAVE_MULTIPLE_LINEAR_OPTION,
  value,
});

// ACTION CREATOR SET_SAVE_STRING_GRID_SELECT
export const SET_SAVE_STRING_GRID_SELECT = 'SET_SAVE_STRING_GRID_SELECT';

// ACTION CREATOR setSaveStringGridSelect
export const setSaveStringGridSelect = (value) => ({
  type: SET_SAVE_STRING_GRID_SELECT,
  value,
});

// ACTION CREATOR SET_SAVE_MULTIPLE_STATIONS_SELECTED
export const SET_SAVE_MULTIPLE_STATIONS_SELECTED = 'SET_SAVE_MULTIPLE_STATIONS_SELECTED';

// ACTION CREATOR setSaveMultipleStationSelected
export const setSaveMultipleStationSelected = (value) => ({
  type: SET_SAVE_MULTIPLE_STATIONS_SELECTED,
  value,
});

// ACTION CREATOR SET_MULTIPLE_METADATA_STRING
export const SET_MULTIPLE_METADATA_STRING = 'SET_MULTIPLE_METADATA_STRING';

// ACTION CREATOR setMultipleMetadataString
export const setMultipleMetadataString = (value) => ({
  type: SET_MULTIPLE_METADATA_STRING,
  value,
});

// ACTION CREATOR FETCH_ADVANCED_SEARCH
export const FETCH_ADVANCED_SEARCH = 'FETCH_ADVANCED_SEARCH';

// ACTION CREATOR fetchAdvancedSearch
export const fetchAdvancedSearch = (query, server, glassapi) => ({
  type: FETCH_ADVANCED_SEARCH,
  query,
  server,
  glassapi,
});

// ACTION CREATOR SET_MODAL_NO_DATA
export const SET_MODAL_NO_DATA = 'SET_MODAL_NO_DATA';

// ACTION CREATOR setModalNoData
export const setModalNoData = (value) => ({
  type: SET_MODAL_NO_DATA,
  value,
});

// ACTION CREATOR SET_DATA_PERCENT
export const SET_DATA_PERCENT = 'SET_DATA_PERCENT';

// ACTION CREATOR setDataPercent
export const setDataPercent = (value) => ({
  type: SET_DATA_PERCENT,
  value,
});

// ACTION CREATOR SET_TIMESERIES
export const SET_TIMESERIES = 'SET_TIMESERIES';

// ACTION CREATOR setTimeseries
export const setTimeseries = (value) => ({
  type: SET_TIMESERIES,
  value,
});

// ACTION SAVE_LOCATION_MULTIPLE_METADATA
export const SAVE_LOCATION_MULTIPLE_METADATA = 'SAVE_LOCATION_MULTIPLE_METADATA';

// ACTION CREATOR saveLocationMultipleMetadata
export const saveLocationMultipleMetadata = (value) => ({
  type: SAVE_LOCATION_MULTIPLE_METADATA,
  value,
});

// ACTION SET_MODAL_ERR_CO
export const SET_MODAL_ERR_CO = 'SET_MODAL_ERR_CO';

// ACTION CREATOR setModalErrCo
export const setModalErrCo = (value) => ({
  type: SET_MODAL_ERR_CO,
  value,
});

// ACTION SET_ERROR_CODE
export const SET_ERROR_CODE = 'SET_ERROR_CODE';

// ACTION CREATOR setErrorCode
export const setErrorCode = (value) => ({
  type: SET_ERROR_CODE,
  value,
});

// ACTION SET_ERROR_CODE
export const SET_ERROR_STATUS = 'SET_ERROR_STATUS';

// ACTION CREATOR setErrorStatus
export const setErrorStatus = (value) => ({
  type: SET_ERROR_STATUS,
  value,
});
